module.exports = __webpack_public_path__ + "static/img/phone.d87285a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/floor7/phone.png
// module id = 3Xcw
// module chunks = 2